/**
 * Non-production environment badge.
 *
 * Renders a thin amber bar at the top of every page (auth pages, app shell,
 * legal pages, everything) when VITE_APP_ENV is not 'production'. Hidden on
 * prod. Lives in App.tsx, above the Routes, so it shows regardless of which
 * route matches.
 */
const APP_ENV = (import.meta.env.VITE_APP_ENV as string | undefined) ?? 'local';
const IS_NON_PROD = APP_ENV !== 'production';

export function EnvBadge() {
  if (!IS_NON_PROD) return null;
  return (
    <div
      role="status"
      aria-label={`Non-production environment (${APP_ENV})`}
      className="env-badge bg-amber-500 text-amber-950 text-center text-xs py-1.5 px-4 font-medium tracking-wide"
    >
      <span className="uppercase font-semibold mr-2">{APP_ENV} environment</span>
      <span className="hidden sm:inline">- testing only. Data here does not affect production.</span>
      <span className="sm:hidden">- testing only.</span>
    </div>
  );
}
